import { get, post, postBlob, postBlobResponse, put, deletes, patch, baseUrl, schoolUrl, studentUrl, platUrl, aiUrl,teamtestUrl } from '../request.js'


const principalUrl = 'https://www.ai-lingxin.com:6443/api/principal'
const studentApiUrl = 'https://www.ai-lingxin.com:6443/api/student'
const teacherApiUrl = 'https://www.ai-lingxin.com:6443/api'
//团体测试
export function teamtestindex(params) {
  return post(`${teamtestUrl}/index`, params)
}
export function teamtestdetail(params) {
  return post(`${teamtestUrl}/detail`, params)
}
export function teamtestsave(params) {
  return post(`${teamtestUrl}/save`, params)
}
export function teamtestpublish(params) {
  return post(`${teamtestUrl}/publish`, params)
}
export function teamtestdelete(params) {
  return post(`${teamtestUrl}/delete`, params)
}
export function teamtestUrl_selectable_scales(params) {
  return get(`${teacherApiUrl}/teamtest/choice/selectable_scales`, params)
}
export function upload_questions(params) {
  return post(`${teamtestUrl}/upload_questions`, params)
}
export function stu_by_id(params) {
  return post(`${teamtestUrl}/stu_by_id`, params)
}
export function stu_report(params) {
  return post(`${teamtestUrl}/stu_report`, params)
}
export function generate_report(params) {
  return post(`${aiUrl}/api/teamtest/new-report/generate`, params)
}
export function teamtestUrlreport(params) {
  return post(`${aiUrl}/api/teamtest/new-report/get-report`, params)
}
export function teamtestUrlreport_detail(params) {
  return post(`${aiUrl}/api/teamtest/choice/report`, params)
}
export function teamtestUrlstatistics(params) {
  return post(`${teamtestUrl}/dashboard/statistics`, params)
}
export function teamtestUrlresults(params) {
  return post(`${teamtestUrl}/dashboard/results`, params)
}
export function teamtestsubjects(params) {
  return post(`${teamtestUrl}/dashboard/subjects`, params)
}
export function teamtestgrade_analysis(params) {
  return post(`${teamtestUrl}/dashboard/grade_analysis`, params)
}
export function teamtesttrend_analysis(params) {
  return post(`${teamtestUrl}/dashboard/trend_analysis`, params)
}
export function save_stu_advice(params) {
  return post(`${teamtestUrl}/save_stu_advice`, params)
}
export function psy_file_upload(params) {
  return post(`${teamtestUrl}/psy_file_upload`, params)
}
export function save_stu_psy_file(params) {
  return post(`${teamtestUrl}/save_stu_psy_file`, params)
}
export function get_stu_psy_config(params) {
  return post(`${teamtestUrl}/get_stu_psy_config`, params)
}
export function save_stu_psy_interview(params) {
  return post(`${teamtestUrl}/save_stu_psy_interview`, params)
}
export function get_stu_list_by_result(params) {
  return post(`${teamtestUrl}/get_stu_list_by_result`, params)
}
export function tuning_get(params) {
  return post(`${teamtestUrl}/tuning/get`, params)
}
export function tuning_save(params) {
  return post(`${teamtestUrl}/tuning/save`, params)
}
export function tuning_page(params) {
  return post(`${teamtestUrl}/tuning/page`, params)
}
export function teamtest_question_preview( params) {
  return post(`${aiUrl}/api/teamtest/choice/question_preview`, params)
}
export function teamtest_student_question_preview(params) {
  return post(`${aiUrl}/api/teamtest/choice/student_question_preview`, params)
}
export function student_question_preview(assess_id,student_id, params) {
  return get(`${aiUrl}/api/choice/{assess_id}/{student_id}/student_question_preview`, params)
}
export function teamtest_record(assess_id,params) {
  return get(`${aiUrl}/api/teamtest/choice/${assess_id}/record`, params)
}
export function choice_home_process(params) {
  return post(`${aiUrl}/api/school/student_choice/choice_home_progress`, params)
}
export function completion_status_list(params) {
  return post(`${teamtestUrl}/completion_status_list`, params)
}
export function teamtest_update_student_warning(params) {
  return post(`${teamtestUrl}/update_student_warning`, params)
}
export function pending_assessments(params) {
  return post(`${aiUrl}/api/teamtest/choice/student/pending_assessments`, params)
}
export function completed_assessments(params) {
  return post(`${aiUrl}/api/teamtest/choice/student/completed_assessments`, params)
}
export function start_assessment(params) {
  return post(`${aiUrl}/api/teamtest/choice/student/start_assessment`, params)
}
export function submit_answers(params) {
  return post(`${aiUrl}/api/teamtest/choice/student/submit_answers`, params)
}
export function weekly_setup(params) {
  return post(`${aiUrl}/api/counselor/schedule/weekly-setup`, params)
}
export function weekly_setup_counselor(counselor_id,params) {
  return get(`${aiUrl}/api/counselor/schedule/weekly/${counselor_id}`, params)
}
export function choice_home_pending_assessments(params) {
  return post(`${aiUrl}/api/school/student_choice/choice_home_pending_assessments`, params)
}
export function choice_home_completed_assessments(params) {
  return post(`${aiUrl}/api/school/student_choice/choice_home_completed_assessments`, params)
}
export function select_school(params) {
  return post(`${aiUrl}/api/school/select_school`, params)
}
//plat接口
export function mentalPlatLogin(params) {
  return post(`${aiUrl}/api/plat/login`, params)
}
export function mentalPlatAdminDetail(params) {
  return post(`${aiUrl}/api/plat/adminDetail`, params)
}
export function mentalPlatRoleDetail(params) {
  return post(`${aiUrl}/api/plat/role/detail`, params)
}
export function mentalPlatGetSchoolType(params) {
  return post(`${aiUrl}/api/plat/guest/getSchoolType`, params)
}
export function mentalPlatGetSchoolList(params) {
  return post(`${aiUrl}/api/plat/schoolIndex`, params)
}
export function mentalPlatGetAreas(params) {
  return post(`${aiUrl}/api/plat/guest/getAreas`, params)
}

export function changeSchoolStatus(params) {
  return post(`${aiUrl}/api/plat/changeSchoolStatus`, params)
}
export function saveSchool(params) {
  return post(`${aiUrl}/api/plat/saveSchool`, params)
}
export function getSchoolType(params) {
  return post(`${aiUrl}/api/plat/guest/getSchoolType`, params)
}
export function deleteSchool(params) {
  return post(`${aiUrl}/api/plat/deleteSchool`, params)
}

const educationDashboardBase = `${aiUrl}/api/education/dashboard`;

const EDU_HEADER = { headers: { 'X-Use-Edu-Token': true } };

export function getEducationSchoolStats(params = {}) {
  return post(`${educationDashboardBase}/school_stats`, params, EDU_HEADER);
}

export function getEducationWarningStats(params = {}) {
  return post(`${educationDashboardBase}/warning_stats`, params, EDU_HEADER);
}

export function getEducationStageGender(params = {}) {
  return post(`${educationDashboardBase}/education_stage_gender`, params, EDU_HEADER);
}

export function getEducationWarningAgeGender(params = {}) {
  return post(`${educationDashboardBase}/warning_student_age_gender`, params, EDU_HEADER);
}

export function getEducationAssessmentResultDistribution(params = {}) {
  return post(`${educationDashboardBase}/assessment_result_distribution`, params, EDU_HEADER);
}

export function getEducationWarningFactorDistribution(params = {}) {
  return post(`${educationDashboardBase}/warning_factor_distribution`, params, EDU_HEADER);
}

export function getEducationSchoolStudentCount(params = {}) {
  return post(`${educationDashboardBase}/school_student_count`, params, EDU_HEADER);
}

export function getEducationTotalWarningLevelDistribution(params = {}) {
  return post(`${educationDashboardBase}/total_warning_level_distribution`, params, EDU_HEADER);
}

export function getEducationSchoolWarningDetail(params = {}) {
  return post(`${educationDashboardBase}/school_warning_detail`, params, EDU_HEADER);
}

export function getEducationSchoolAssessmentCount(params = {}) {
  return post(`${educationDashboardBase}/school_assessment_count`, params, EDU_HEADER);
}

export function getEducationSemesterAssessmentCount(params = {}) {
  return post(`${educationDashboardBase}/semester_assessment_count`, params, EDU_HEADER);
}

export function getEducationWarningTrend(params = {}) {
  return post(`${educationDashboardBase}/warning_trend`, params, EDU_HEADER);
}

export function getEducationSchoolWarningLevelDetail(params = {}) {
  return post(`${educationDashboardBase}/school_warning_level_detail`, params, EDU_HEADER);
}

export function getEducationTotalPositiveFactorDistribution(params = {}) {
  return post(`${educationDashboardBase}/total_positive_factor_distribution`, params, EDU_HEADER);
}

export function getEducationWarningStudentPositiveFactor(params = {}) {
  return post(`${educationDashboardBase}/warning_student_positive_factor`, params, EDU_HEADER);
}
export function total_positive_factor_distribution(params = {}) {
  return post(`${educationDashboardBase}/total_positive_factor_distribution`, params, EDU_HEADER);
}
// 登录接口
export function EducationLogin(params) {
  return post(`${aiUrl}/api/education/login`, params)
}
// 登录接口
export function mentalLogin(params) {
  return post(`${baseUrl}/login`, params)
}
export function switchLogin(params) {
  return post(`${baseUrl}/switch_login`, params)
}
// 退出登录接口
export function mentalLogout() {
  return post(`${baseUrl}/logout`)
}
// 个人基本信息接口
export function basicInfo() {
  return post(`${baseUrl}/basic_info`)
}
// 修改密码接口
export function updatePassword(params) {
  return post(`${baseUrl}/update_password`, params)
}
// 意见反馈/申诉接口
export function submitAppeal(params) {
  return post(`${teacherApiUrl}/audit/appeals`, params)
}
// 学生基本信息接口
export function profileinfo() {
  return post(`${baseUrl}/profile/info`)
}
// 修改学生基本信息接口
export function updateProfile(params) {
  return post(`${baseUrl}/profile/update`, params)
}
// 修改学生密码接口
export function upload_avatar(params) {
  return post(`${baseUrl}/profile/upload_avatar`, params)
}
// 操作日志接口
export function operation_logs(params) {
  return post(`${baseUrl}/profile/operation_logs`, params)
}
// 个人资料接口
export function complete_scale_page(params) {
  return post(`${baseUrl}/student/complete_scale_page`, params)
}
// 个人资料接口
export function pending_scale_page(params) {
  return post(`${baseUrl}/student/pending_scale_page`, params)
}
// 新增：心理数据设置
export function recent_activities(params) {
  return post(`${baseUrl}/teacher_profile/recent_activities`, params)
}
// 操作日志接口
export function profile_statistics(params) {
  return post(`${baseUrl}/profile/statistics`, params)
}
// 新增：设置与账户信息
export function setTheme(params) {
  return post(`${baseUrl}/settings/theme`, params)
}
export function setLanguage(params) {
  return post(`${baseUrl}/settings/language`, params)
}
export function setNotifications(params) {
  return post(`${baseUrl}/settings/notifications`, params)
}
export function getAccountSettings() {
  return post(`${baseUrl}/settings/account_settings`)
}
// 首页获取老师绑定的班级列表接口
export function teacherClass() {
  return post(`${schoolUrl}/class/list_by_teacher`)
}
// 首页预警分析统计接口
export function warningStats(params) {
  return post(`${schoolUrl}/home/waring_stats`, params)
}
// 首页数字概览统计接口
export function homeStats() {
  return post(`${schoolUrl}/home/overview`)
}
// 首页量表使用类型分析统计接口
export function scaleStats() {
  return post(`${schoolUrl}/home/scale_stats`)
}
// 未测评学生和预警学生列表接口
export function warningList(params) {
  return post(`${schoolUrl}/home/ts_stu_list`, params)
}
// 老师类型接口
export function teacherTypes() {
  return post(`${schoolUrl}/teacher/type_list`)
}
// 老师信息保存接口
export function saveTeacher(params) {
  return post(`${schoolUrl}/teacher/save`, params)
}
// 老师信息详情接口
export function teacherInfo(params) {
  return post(`${schoolUrl}/teacher/detail`, params)
}
// 老师信息删除接口
export function delTeacher(params) {
  return post(`${schoolUrl}/teacher/delete`, params)
}
// 老师信息列表接口
export function teacherList(params) {
  return post(`${schoolUrl}/teacher/index`, params)
}
// 老师重置密码接口
export function teacherPassword(params) {
  return post(`${schoolUrl}/teacher/reset_password`, params)
}
// 班级保存接口
export function saveClass(params) {
  return post(`${schoolUrl}/class/save`, params)
}
// 班级详情接口
export function classInfo(params) {
  return post(`${schoolUrl}/class/detail`, params)
}
// 班级删除接口
export function delClass(params) {
  return post(`${schoolUrl}/class/delete`, params)
}
// 班级列表接口
export function classList(params) {
  return post(`${schoolUrl}/class/index`, params)
}
// 班级年级列表接口
export function allClass() {
  return post(`${schoolUrl}/class/class_list`)
}
// 学生信息保存接口
export function saveStudent(params) {
  return post(`${schoolUrl}/student/save`, params)
}
// 学生信息详情接口
export function studentInfo(params) {
  return post(`${schoolUrl}/student/detail`, params)
}
// 学生信息删除接口
export function delStudent(params) {
  return post(`${schoolUrl}/student/delete`, params)
}
// 学生信息列表接口
export function studentList(params) {
  return post(`${schoolUrl}/student/index`, params)
}
// 学生重置密码接口
export function studentPassword(params) {
  return post(`${schoolUrl}/student/reset_password`, params)
}
// 根据班级获取学生列表接口
export function classStudent(params) {
  return post(`${schoolUrl}/class/cls_stu_list`, params)
}
// 个人特质信息接口
export function traitInfo(params) {
  return get(`${aiUrl}/api/user_characteristic_information/` + params + `/get_information`)
}
// 特质信息列表接口
export function traitList() {
  return get(`${aiUrl}/api/user_characteristic_information/get_information`)
}
// 保存特质信息接口
export function saveTrait(params) {
  return post(`${aiUrl}/api/user_characteristic_information/put_information`, params)
}
// 学生备注保存列表接口
export function saveMark(params) {
  return post(`${schoolUrl}/student/save_mark`, params)
}
// 导出接口
export function downloadFile(params) {
  return post(`${schoolUrl}/download_template`, params)
}
// 使用blob下载模板（供批量导入弹窗使用，避免依赖完整URL）
export function downloadTemplateBlob(params) {
  return postBlob(`${schoolUrl}/download_template`, params)
}
// 返回包含headers的blob响应用于提取文件名
export function downloadTemplateBlobResponse(params) {
  return postBlobResponse(`${schoolUrl}/download_template`, params)
}
// 导入接口
export function importFile(params) {
  return post(`${schoolUrl}/import`, params)
}
// 系统日志类型接口
export function systemType() {
  return post(`${schoolUrl}/system_log/type`)
}
// 系统日志列表接口
export function systemLog(params) {
  return post(`${schoolUrl}/system_log/index`, params)
}
// 团测列表接口
export function testList(params) {
  return post(`${schoolUrl}/team_assess/index`, params)
}
// 创建团测选择量表接口
export function scaleList() {
  return get(`${aiUrl}/api/teamtest/selectable_scales`)
}
// 生成团测题目接口
export function createQuestion(params) {
  return post(`${aiUrl}/api/teamtest/question_preview`, params)
}
// 团测题目预览接口
export function previewQuestion(params) {
  return get(`${aiUrl}/api/teamtest/` + params + `/student_question_preview`)
}
// 团测详情量表接口
export function testRecord(params) {
  return get(`${aiUrl}/api/teamtest/` + params + `/record`)
}
// 创建团测选择学生接口
export function scaleStudents(params) {
  return post(`${schoolUrl}/class/grade_class_group`, params)
}
// 创建团测接口
export function saveScale(params) {
  return post(`${schoolUrl}/team_assess/save`, params)
}
// 团测详情接口
export function scaleInfo(params) {
  return post(`${schoolUrl}/team_assess/detail`, params)
}
// 团测删除接口
export function delScale(params) {
  return post(`${schoolUrl}/team_assess/delete`, params)
}
// 团测发布接口
export function publishScale(params) {
  return post(`${schoolUrl}/team_assess/publish`, params)
}
// 生成团测报告接口
export function createReport(params) {
  return post(`${aiUrl}/api/teamtest_report`, params)
}
// 团测团体报告接口
export function teamReport(params) {
  return post(`${schoolUrl}/team_assess/report`, params)
}
// 团测学生列表接口
export function teamStudents(params) {
  return post(`${schoolUrl}/team_assess/stu_by_id`, params)
}
// 学生测评报告接口
export function studentReport(params) {
  return post(`${schoolUrl}/team_assess/stu_report`, params)
}
// 保存学生测评建议接口
export function saveAdvice(params) {
  return post(`${schoolUrl}/team_assess/save_stu_advice`, params)
}
// 学生档案测评记录接口
export function studentRecord(params) {
  return post(`${schoolUrl}/student/assess_record`, params)
}
// 职业生涯列表接口
export function careerList(params) {
  return post(`${schoolUrl}/career/index`, params)
}
// 职业生涯学生报告接口
export function careerAnalysis(params) {
  return post(`${schoolUrl}/career/stu_report`, params)
}
// 学段选项接口
export function selectPeriod() {
  return post(`${schoolUrl}/class/select_period`)
}
// 角色列表接口
export function roleList(params) {
  return post(`${schoolUrl}/role/page`, params)
}
// 角色保存接口
export function saveRole(params) {
  return post(`${schoolUrl}/role/save`, params)
}
// 角色详情接口
export function roleInfo(params) {
  return post(`${schoolUrl}/role/detail`, params)
}
// 角色删除接口
export function delRole(params) {
  return post(`${schoolUrl}/role/delete`, params)
}
// 归档文件上传接口
export function fileUpload(params) {
  return post(`${schoolUrl}/team_assess/psy_file_upload`, params)
}
// 归档文件保存接口
export function saveFile(params) {
  return post(`${schoolUrl}/team_assess/save_stu_psy_file`, params)
}
// 访谈选项接口
export function interviewConfig() {
  return post(`${schoolUrl}/team_assess/get_stu_psy_config`)
}
// 访谈信息保存接口
export function interviewSave(params) {
  return post(`${schoolUrl}/team_assess/save_stu_psy_interview`, params)
}
// 团测调优详情接口
export function tuningInfo(params) {
  return post(`${schoolUrl}/team_assess/tuning/get`, params)
}
// 团测调优保存接口
export function tuningSave(params) {
  return post(`${schoolUrl}/team_assess/tuning/save`, params)
}
// 团测调优记录接口
export function tuningRecord(params) {
  return post(`${schoolUrl}/team_assess/tuning/page`, params)
}
// 自我测评列表接口
export function selfList(params) {
  return post(`${schoolUrl}/selfassess/index`, params)
}
// 自我测评详情接口
export function selfInfo(params) {
  return post(`${schoolUrl}/selfassess/detail`, params)
}
// 自我测评详情获取某段学生情况接口
export function selfMark(params) {
  return post(`${schoolUrl}/selfassess/stu_list_by_mark`, params)
}
// 认知训练列表接口
export function gameList(params) {
  return post(`${schoolUrl}/game/index`, params)
}
// 认知训练详情接口
export function gameInfo(params) {
  return post(`${schoolUrl}/game/detail`, params)
}
// 学生密码设置保存接口
export function saveSetting(params) {
  return post(`${schoolUrl}/system_setting/save`, params)
}
// 密码设置详情接口
export function getSetting() {
  return post(`${schoolUrl}/system_setting/detail`)
}
// 对话灵悦未成年人使用时长设置详情接口
export function getLingyueUsagePolicy() {
  return get(`${schoolUrl}/lingyue_usage_policy/detail`)
}
// 对话灵悦未成年人使用时长设置保存接口
export function saveLingyueUsagePolicy(params) {
  return post(`${schoolUrl}/lingyue_usage_policy/save`, params)
}
// 获取团测结果的学生接口
export function warningStudents(params) {
  return post(`${schoolUrl}/team_assess/get_stu_list_by_result`, params)
}
// 消息类型接口
export function msgType() {
  return post(`${schoolUrl}/notices/type`)
}
// 消息列表接口
export function msgList(params) {
  return post(`${schoolUrl}/notices/index`, params)
}
// 消息详情接口
export function msgCont(params) {
  return post(`${schoolUrl}/notices/detail`, params)
}
// 未读消息数量接口
export function msgCount() {
  return post(`${schoolUrl}/notices/not_read_count`)
}
// 老师首页数据1
export function teacher_overview() {
  return post(`${schoolUrl}/home_page/teacher_overview`)
}
// 老师首页数据2
export function get_active_num() {
  return post(`${schoolUrl}/home_page/get_active_num`)
}
// 老师首页数据3
export function cognitive_training_overview(params) {
  return post(`${schoolUrl}/home_page/cognitive_training_overview`,params)
}
// 老师首页数据4
export function team_overview(params) {
  return post(`${schoolUrl}/home_page/team_overview`,params)
}
// 老师首页数据5
export function psychologic_consult_overview(params) {
  return post(`${schoolUrl}/home_page/psychologic_consult_overview`,params)
}
// 老师首页数据6
export function psychologic_table_overview(params) {
  return post(`${schoolUrl}/home_page/psychologic_table_overview`,params)
}
 // 老师首页数据7
export function intervene_overview(params) {
  return post(`${schoolUrl}/home_page/intervene_overview`,params)
}
// 预警学生列表接口
export function warning_students(params) {
  return post(`${schoolUrl}/notices/warning_students`,params)
}
// 预警学生列表下载接口
export function warning_students_download(params) {
  return postBlob(`${schoolUrl}/notices/warning_students/download`,params)
}
// 团测学生列表接口
export function team_assess_students(params) {
  return post(`${schoolUrl}/notices/team_assess_students`,params)
}
// 更新预警学生接口
export function update_student_warning(params) {
  return post(`${schoolUrl}/notices/update_student_warning`,params)
}
// 重置学生论述题测评接口
export function reset_student_assessment(params) {
  return post(`${schoolUrl}/notices/reset_student_assessment`,params)
}
// 重置学生选择题测评接口
export function reset_student_choice_assessment(params) {
  return post(`${teamtestUrl}/reset_student_choice_assessment`,params)
}
// 团测工作台数据接口
export function team_assess_statistics(params) {
  return post(`${schoolUrl}/team_assess/dashboard/statistics`,params)
}
// 团测工作台结果接口
export function team_assess_results(params) {
  return post(`${schoolUrl}/team_assess/dashboard/results`,params)
}
// 团测工作台量表列表接口
export function team_assess_subjects(params) {
  return post(`${schoolUrl}/team_assess/dashboard/subjects`,params)
}
// 团测工作台年级分析接口
export function team_assess_grade_analysis(params) {
  return post(`${schoolUrl}/team_assess/dashboard/grade_analysis`,params)
}
// 团测工作台班级分析接口
export function team_assess_trend_analysis(params) {
  return post(`${schoolUrl}/team_assess/dashboard/trend_analysis`,params)
}
export function team_assess_statistics_choice(params) {
  return post(`${aiUrl}/api/teamtest/choice/dashboard/statistics`,params)
}
export function team_assess_results_choice(params) {
  return post(`${aiUrl}/api/teamtest/choice/dashboard/results`,params)
}
export function team_assess_subjects_choice(params) {
  return post(`${aiUrl}/api/teamtest/choice/dashboard/subjects`,params)
}
export function team_assess_grade_analysis_choice(params) {
  return post(`${aiUrl}/api/teamtest/choice/dashboard/grade_analysis`,params)
}
export function team_assess_trend_analysis_choice(params) {
  return post(`${aiUrl}/api/teamtest/choice/dashboard/trend_analysis`,params)
}
export function submit_part_answers(params) {
  return post(`${aiUrl}/api/teamtest/choice/student/submit_part_answers`,params)
}
// 学生端
// 待完成测评列表接口
export function pendingList(params) {
  return post(`${studentUrl}/pending_scale_page`, params)
}
// 已完成测评列表接口
export function completeList(params) {
  return post(`${studentUrl}/complete_scale_page`, params)
}
// 测评题目接口
export function questionList(params) {
  return post(`${studentUrl}/get_ts_detail`, params)
}
// 测评详情接口
export function questionDetail(params) {
  return get(`${aiUrl}/api/teamtest_send_message/` + params + `/teamtest_content`)
}

// 提交团测答题文字接口
export function saveTeamTest(params) {
  return post(`${aiUrl}/api/teamtest_send_message/send_text`, params)
}
// 提交团测答题语音接口
export function saveAudioTest(params) {
  return post(`${aiUrl}/api/teamtest_send_message/upload_audio`, params)
}
// 学生端首页进度接口
export function home_progress(params) {
  return post(`${studentUrl}/home_progress`,params)
}
// 学生端首页待完成测评接口
export function home_pending_assessments(params) {
  return post(`${studentUrl}/home_pending_assessments`,params)
}
// 学生端首页已完成测评接口
export function home_completed_assessments(params) {
  return post(`${studentUrl}/home_completed_assessments`,params)
}
// 提交答题接口
export function saveTest(params) {
  return post(`${studentUrl}/submit_ts_detail`, params)
}
// 生成音频接口
export function radioPlay(params) {
  return post(`${aiUrl}/api/radio_playback`, params)
}
// 学生测评报告接口
export function reportInfo(params) {
  return post(`${studentUrl}/report`, params)
}
// 自我测评类型接口
export function assessCategory() {
  return post(`${studentUrl}/self_assess_category`)
}
// 自我测评未完成列表接口
export function selfPending(params) {
  return post(`${studentUrl}/self_assess_page`, params)
}
// 自我测评详情接口
export function selfAssess(params) {
  return post(`${studentUrl}/get_self_assess_detail`, params)
}
// 自我测评提交接口
export function saveSelf(params) {
  return post(`${studentUrl}/submit_self_assess_detail`, params)
}
// 自我测评已完成列表接口
export function selfComplete(params) {
  return post(`${studentUrl}/get_self_assess_logs`, params)
}
// 自我测评报告接口
export function selfReport(params) {
  return post(`${studentUrl}/get_self_assess_report`, params)
}
// 职业生涯详情接口
export function careerPlan(params) {
  return post(`${studentUrl}/get_career_plan_detail`, params)
}
// 职业生涯提交接口
export function saveCareer(params) {
  return post(`${studentUrl}/submit_career_assess_detail`, params)
}
// 职业生涯报告接口
export function careerReport(params) {
  return post(`${studentUrl}/get_career_assess_report`, params)
}
// 认知训练列表接口
export function trainList(params) {
  return post(`${studentUrl}/game_page`, params)
}
// 家长绑定列表接口
export function bindList(params) {
  return post(`${studentUrl}/get_bind_page`, params)
}
// 审核绑定接口
export function examineBind(params) {
  return post(`${studentUrl}/bind_approval`, params)
}
// 共用接口
// 备案信息接口
export function websiteInfo(params) {
  return post(`${platUrl}/getWebsiteInfo`, params)
}
// 干预手段列表
export function interveneList(params) {
  return post(`${baseUrl}/intervene/page`, params)
}
// 干预手段详情
export function interveneDetail(params) {
  return post(`${baseUrl}/intervene/detail`, params)
}
// 对话灵悦
// 推送消息
export function pushMsg(params) {
  return post(`${aiUrl}/push_message`, params)
}
// 获取会话列表
export function sessionList(params) {
  return post(`${aiUrl}/api/get_session_list`, params)
}
// 会话内容
export function sessionCont(params) {
  return post(`${aiUrl}/api/get_session_content`, params)
}
// 删除会话
export function delSession(params) {
  return post(`${aiUrl}/api/delete_session`, params)
}
// 发送消息
export function sendMsg(params) {
  return post(`${aiUrl}/api/send_message`, params)
}
// future you发送消息
export function send_message(params) {
  return post(`${aiUrl}/future_dialogue/send_message`, params)
}
// 上传音频
export function uploadAudio(params) {
  return post(`${aiUrl}/api/upload_audio`, params)
}
// future you上传音频
export function upload_audio(params) {
  return post(`${aiUrl}/future_dialogue/upload_audio`, params)
}
// future you发送语音
export function send_audio(params) {
  return post(`${aiUrl}/future_dialogue/send_audio`, params)
}
// 上传图片
export function uploadImg(params) {
  return post(`${aiUrl}/api/upload_image`, params)
}
// 结束会话
export function endSession(params) {
  return post(`${aiUrl}/api/mental_health_strategy`, params)
}
// future you结束会话
export function future_dialogue_end(params) {
  return post(`${aiUrl}/api/future_dialogue_end`, params)
}
// 日志
export function sessionLog(params) {
  return post(`${aiUrl}/api/get_session_log`, params)
}
// 未来自我形象创建
export function create_future_image(params) {
  return post(`${aiUrl}/api/future_dialogue/create_future_image`, params)
}
// 获取对话灵悦历史记录
export function future_dialogue_history(user_id) {
  return get(`${aiUrl}/api/future_dialogue_history/${user_id}`)
}

// 获取对话灵悦对话列表
export function getDialogueList(params) {
  return get(`${aiUrl}/api/future_dialogue_list`, { params })
}

// 获取对话灵悦对话详情
export function getDialogueDetail(dialogue_id) {
  return get(`${aiUrl}/api/future_dialogue/${dialogue_id}`)
}
// /future_dialogue/upload_image
export function upload_image(params) {
  return post(`${aiUrl}/future_dialogue/upload_image`, params)
}
// 生活片段的生成
export function fragment_create(params) {
  return post(`${aiUrl}/api/future_dialogue/fragment_create`, params)
}
export function choice_assess_export_excel(data) {
  return post(`${aiUrl}/api/teamtest/choice/assess/export_excel`, data)
}

// ========== 功能室管理相关接口 ==========
// 校长账号基础URL
// 学生端基础URL

export function leaveapprove(leave_id, params) {
  return post(`${principalUrl}/leave/${leave_id}/approve`, params)
}
export function leaveDetail(leave_id, params) {
  return get(`${principalUrl}/leave/${leave_id}`, params)
}
export function leaveBatchApprove(params) {
  return post(`${principalUrl}/leave/batch-approve`, params)
}
export function getCounselorsXZ(params) {
  return get(`${principalUrl}/counselors`, params)
}
// 获取功能室列表
export function getRoomsXZ(params) {
  return get(`${principalUrl}/rooms`,params)
}
// 工作台 - 全校预约管理
export function getAppointments(params) {
  return get(`${principalUrl}/appointments`, params)
}

// 工作台 - 全校评价管理
export function getRatings(params) {
  return get(`${principalUrl}/ratings`, params)
}


export function getCounselorDetail(counselorId) {
  return get(`${principalUrl}/counselor/${counselorId}`)
}

export function createCounselor(params) {
  return post(`${principalUrl}/counselor/create`, params)
}

export function updateCounselor(counselorId, params) {
  return put(`${principalUrl}/counselor/${counselorId}`, params)
}

export function deleteCounselor(counselorId) {
  return deletes(`${principalUrl}/counselor/${counselorId}`)
}

export function getPsychologyTeachers(params) {
  return get(`${principalUrl}/psychology-teachers`, params)
}


export function createRoom(params) {
  return post(`${principalUrl}/room/create`, params)
}

export function updateRoom(roomId, params) {
  return put(`${principalUrl}/room/${roomId}`, params)
}

export function deleteRoom(roomId) {
  return deletes(`${principalUrl}/room/${roomId}`)
}

export function setRoomMaintenance(roomId, params) {
  return post(`${principalUrl}/room/${roomId}/maintenance`, params)
}

export function getRoomTypes() {
  return get(`${principalUrl}/room/types`)
}

// 统计分析
export function getStatisticsOverview(params) {
  return get(`${principalUrl}/statistics/overview`, params)
}

export function getStatisticsTrend(params) {
  return get(`${principalUrl}/statistics/trend`, params)
}

export function getCounselorPerformance(params) {
  return get(`${principalUrl}/statistics/counselor-performance`, params)
}

export function getRoomUsage(params) {
  return get(`${principalUrl}/statistics/room-usage`, params)
}

export function getSatisfactionAnalysis(params) {
  return get(`${principalUrl}/statistics/satisfaction-analysis`, params)
}

export function generateCustomReport(params) {
  return post(`${principalUrl}/statistics/generate-report`, params)
}

// 请假管理
export function getLeaveList(params) {
  return get(`${principalUrl}/leave/list`, params)
}

export function getLeaveStatistics(params) {
  return get(`${principalUrl}/leave/statistics`, params)
}
// 查询可用功能室
export function getAvailableRooms(params) {
  return get(`${principalUrl}/rooms/available`,  params )
}

// 自定义量表相关接口
// 下载Excel模板（参数化）
export function downloadCustomScaleTemplate(params) {
  return postBlobResponse(`${aiUrl}/api/teamtest/custom-scales/template/download`, params)
}

// 上传Excel文件
export function uploadCustomScaleExcel(formData) {
  return post(`${aiUrl}/api/teamtest/custom-scales/upload-excel`, formData)
}

// 配置评分标准
export function configScoringRules(params) {
  return post(`${aiUrl}/api/teamtest/custom-scales/scoring-rules`, params)
}

// 保存量表
export function saveCustomScale(params) {
  return post(`${aiUrl}/api/teamtest/custom-scales/save`, params)
}

// 获取可用心理老师（根据日期、时间、房间类型）
export function getAvailableCounselors(params) {
  return get(`${principalUrl}/counselors/available`, params)
}

// ========== 学生端心理咨询管理相关接口 ==========












// 心理咨询管理相关接口

// 学生端心理咨询管理接口
// 获取学生评价统计
export function getRatingsStatistics() {
  return get(`${studentApiUrl}/ratings/statistics`)
}

// 获取学生预约统计
export function getAppointmentsStatistics() {
  return get(`${studentApiUrl}/appointments/statistics`)
}

// 获取学生预约历史
export function getAppointmentHistory(params) {
  return get(`${studentApiUrl}/appointments/history`, params)
}

// 获取学生预约列表
export function getStudentAppointments(params) {
  return get(`${studentApiUrl}/appointments`, params)
}

// 获取心理老师列表
export function getCounselors(params) {
  return get(`${studentApiUrl}/counselors`, params)
}

// 获取心理老师可用时间
export function getCounselorAvailableTimes(counselorId, params) {
  return get(`${studentApiUrl}/counselor/${counselorId}/available-times`,  params )
}

// 创建预约
export function createAppointment(params) {
  return post(`${studentApiUrl}/appointment/create`, params)
}

// 心理老师创建预约记录
export function createTeacherAppointmentRecord(params) {
  return post(`${teacherApiUrl}/appointment/add_appointment`, params)
}

// 取消预约
export function cancelAppointment(appointmentId, params) {
  return post(`${studentApiUrl}/appointment/${appointmentId}/cancel`, params)
}

// 重新安排预约
export function rescheduleAppointment(appointmentId, params) {
  return post(`${studentApiUrl}/appointment/${appointmentId}/reschedule`, params)
}

// 提交评价
export function submitRating(params) {
  return post(`${studentApiUrl}/rating/submit`, params)
}

// 获取咨询报告
export function getConsultationReport(appointmentId) {
  return get(`${studentApiUrl}/appointment/${appointmentId}/report`)
}

// ========== 心理老师评价管理相关接口 ==========
//心理沙盘学生列表
export function sandplaystudents(params) {
  return get(`${teacherApiUrl}/sandplay/students`,  params )
}
//心理沙盘/sandplay/sessions
export function sandplaySessions(params) {
  return post(`${teacherApiUrl}/sandplay/sessions`,  params )
}
//心理沙盘学生咨询列表
export function sandplayStudentsConsultations(studentId) {
  return get(`${teacherApiUrl}/sandplay/students/${studentId}/consultations`)
}
//心理沙盘图片上传
export function sandplayImageUpload(params) {
  return post(`${teacherApiUrl}/sandplay/image/upload`,  params )
}
//心理沙盘图片异步上传
export function sandplayImageUploadAsync(params) {
  return post(`${teacherApiUrl}/sandplay/image/upload-async`,  params )
}
//心理沙盘问题生成
export function sandplayQuestionsGenerate(params) {
  return post(`${teacherApiUrl}/sandplay/questions/generate`,  params )
}
//心理沙盘问题异步生成
export function sandplayQuestionsGenerateAsync(params) {
  return post(`${teacherApiUrl}/sandplay/questions/generate-async`,  params )
}
//心理沙盘问题回答
export function sandplayQuestionsAnswer(params) {
  return post(`${teacherApiUrl}/sandplay/questions/answer`,  params )
}
//心理沙盘获取下一个问题
export function sandplayQuestionsNext(sessionId) {
  return get(`${teacherApiUrl}/sandplay/questions/next/${sessionId}`)
}
//心理沙盘异步任务状态查询
export function sandplayTaskStatus(taskId) {
  return get(`${teacherApiUrl}/sandplay/task/${taskId}/status`)
}
//心理沙盘报告生成
export function sandplayReportGenerate(params) {
  return post(`${teacherApiUrl}/sandplay/report/generate`,  params )
}
//心理沙盘历史会话列表
export function sandplayHistorySessions(params) {
  return get(`${teacherApiUrl}/sandplay/history/sessions?${params}`)
}
//心理沙盘历史会话统计
export function sandplayHistorySessionsStatistics(params) {
  return get(`${teacherApiUrl}/sandplay/history/statistics`,params)
}
//心理沙盘历史会话详情
export function sandplayHistorySessionsDetail(sessionId) {
  return get(`${teacherApiUrl}/sandplay/history/sessions/${sessionId}/detail`)
}
//心理沙盘历史会话删除
export function sandplayHistorySessionsDelete(sessionId) {
  return deletes(`${teacherApiUrl}/sandplay/history/sessions/${sessionId}`)
}
// 获取收到的评价列表
export function getTeacherRatings(params) {
  return get(`${teacherApiUrl}/teacher/ratings`,  params )
}

// 获取评价详情
export function getTeacherRatingDetail(ratingId) {
  return get(`${teacherApiUrl}/teacher/rating/${ratingId}`)
}

// 回复评价
export function replyToRating(ratingId, params) {
  return post(`${teacherApiUrl}/teacher/rating/${ratingId}/reply`, params)
}

// 获取评价统计分析
export function getRatingStatistics(params) {
  return get(`${teacherApiUrl}/teacher/ratings/statistics`, { params })
}

// 获取学生评价列表
export function getStudentRatings(params) {
  return get(`${studentApiUrl}/ratings`, { params })
}

// 获取评价详情
export function getRatingDetail(ratingId) {
  return get(`${studentApiUrl}/rating/${ratingId}`)
}

// 修改评价
export function updateRating(ratingId, params) {
  return put(`${studentApiUrl}/rating/${ratingId}/edit`, params)
}

// 学生查询指定咨询师未来七天的工作详情
export function weekly_schedule(counselorId, params = {}) {
  const query = new URLSearchParams(params).toString()
  const url = query ?
    `${studentApiUrl}/counselor/${counselorId}/weekly-schedule?${query}` :
    `${studentApiUrl}/counselor/${counselorId}/weekly-schedule`
  return get(url)
}

// 删除评价
export function deleteRating(ratingId) {
  return deletes(`${studentApiUrl}/rating/${ratingId}`)
}


// ========== 教师端预约管理相关接口 ==========
// 教师端基础URL

// 教师端心理咨询管理接口
// 获取教师个人信息
export function availabletimes() {
  return get(`${teacherApiUrl}/counselor/available-times`)
}
//获取心理老师可用时间
export function getTeacherProfile() {
  return get(`${teacherApiUrl}/teacher/profile`)
}
// 获取工作台数据
export function getDashboardData() {
  return get(`${teacherApiUrl}/teacher/dashboard`)
}

// 获取教师预约列表
export function getTeacherAppointments(params) {
  return get(`${teacherApiUrl}/teacher/appointments`,  params )
}
// 获取教师预约列表
export function student_appointments(params) {
  return get(`${teacherApiUrl}/school/manage/student/student_appointments`,  params )
}
// 获取教师个人统计
export function getTeacherStatistics(params) {
  return get(`${teacherApiUrl}/teacher/statistics`,  params )
}


// 回复评价
export function replyRating(ratingId, params) {
  return post(`${teacherApiUrl}/teacher/rating/${ratingId}/reply`, params)
}



// 获取预约统计分析
export function getAppointmentStatistics(params) {
  return get(`${teacherApiUrl}/teacher/appointments/statistics`,  params )
}

// 确认预约
export function confirmAppointment(appointmentId, params) {
  return put(`${teacherApiUrl}/teacher/appointment/${appointmentId}/confirm`, params)
}

// 开始咨询
export function startConsultation(appointmentId) {
  return put(`${teacherApiUrl}/teacher/appointment/${appointmentId}/start`)
}

// 完成预约
export function completeAppointment(appointmentId, params) {
  return put(`${teacherApiUrl}/teacher/appointment/${appointmentId}/complete`, params)
}

// 创建咨询记录
export function createAppointmentRecord(appointmentId, params) {
  return post(`${teacherApiUrl}/teacher/appointment/${appointmentId}/record`, params)
}

// 教师取消预约
export function cancelTeacherAppointment(appointmentId, params) {
  return put(`${teacherApiUrl}/teacher/appointment/${appointmentId}/cancel`, params)
}

// 教师重新安排预约
export function rescheduleTeacherAppointment(appointmentId, params) {
  return post(`${teacherApiUrl}/teacher/appointment/${appointmentId}/reschedule`, params)
}

// 获取预约详情
export function getAppointmentDetail(appointmentId) {
  return get(`${teacherApiUrl}/teacher/appointment/${appointmentId}`)
}
export function studentAppointmentDetail(appointmentId) {
  return get(`${teacherApiUrl}/school/manage/student/student_appointment/${appointmentId}`)
}
// 获取预约历史日历
export function getAppointmentCalendar(params) {
  return get(`${teacherApiUrl}/teacher/appointments/calendar`,  params )
}


// 获取功能室列表
export function getRooms() {
  return get(`${teacherApiUrl}/counseling/rooms`)
}

// 获取排班信息
export function getTeacherSchedule(params) {
  return get(`${teacherApiUrl}/teacher/schedule`,  params )
}

// 创建排班
export function createSchedule(params) {
  return post(`${teacherApiUrl}/teacher/schedule`, params)
}

// 更新排班
export function updateSchedule(scheduleId, params) {
  return put(`${teacherApiUrl}/teacher/schedule/${scheduleId}`, params)
}

// 删除排班
export function deleteSchedule(scheduleId) {
  return deletes(`${teacherApiUrl}/teacher/schedule/${scheduleId}`)
}

// 申请请假
export function applyLeave(params) {
  return post(`${teacherApiUrl}/teacher/leave/apply`, params)
}

// 获取请假记录
export function getLeaveRecords(params) {
  return get(`${teacherApiUrl}/teacher/leave/list`,  params )
}

// 取消请假申请
export function cancelLeave(leaveId) {
  // 使用DELETE方法，并确保请求头正确配置
  return put(`${teacherApiUrl}/teacher/leave/${leaveId}/cancel`)
}

// 查看报告
export function viewReport(params) {
  return post(`${teacherApiUrl}/teacher/appointment/view/report`, params)
}

// 校长工作台接口
export function getPrincipalDashboard() {
  return get(`${principalUrl}/dashboard`)
}

// 提交游戏成绩接口
export function submitGameResult(params) {
  return post(`${studentUrl}/submit_game_result`, params)
}

// 学生Excel导出接口
export function exportStudentExcel(params) {
  return postBlobResponse(`${aiUrl}/api/school/manage/student/export_excel`, params)
}

// 学生团测记录列表（个人档案页）
// POST /api/school/manage/student/teamtest_record_list
export function getStudentTeamtestRecordList(params) {
  return post(`${schoolUrl}/student/teamtest_record_list`, params)
}

// 学校选择接口
export function selectSchoolApi(params) {
  return post(`${baseUrl}/school/select_school`, params)
}

// ========== 心理老师预约统计PDF导出接口 ==========

// 创建PDF导出任务（异步模式）
export function createAppointmentStatisticsPDFTask(params) {
  return get(`${teacherApiUrl}/teacher/appointments/statistics/export`, params)
}

// 查询PDF导出任务状态
export function getAppointmentStatisticsPDFTaskStatus(taskId) {
  return get(`${teacherApiUrl}/teacher/appointments/statistics/export/status/${taskId}`)
}

// 下载已生成的PDF文件 - 需要直接处理blob响应，暂时保留fetch调用
export function downloadAppointmentStatisticsPDF(taskId) {
  const token = localStorage.getItem('mental_token')
  return fetch(`${teacherApiUrl}/teacher/appointments/statistics/export/download/${taskId}`, {
    method: 'GET',
    headers: {
      'token': token,
      'Authorization': `Bearer ${token}`
    }
  })
}

// 同步导出PDF报告（备用模式）
export function exportAppointmentStatisticsPDFSync(params) {
  return get(`${teacherApiUrl}/teacher/appointments/statistics/export-sync`, params)
}

// ========== 预约详情PDF导出接口 ==========

// 创建预约详情PDF导出任务
export function createAppointmentDetailExportTask(appointmentId) {
  return get(`${aiUrl}/api/teacher/appointment/${appointmentId}/export`)
}

// 查询预约详情PDF导出任务状态
export function getAppointmentDetailExportStatus(appointmentId, taskId) {
  return get(`${aiUrl}/api/teacher/appointment/${appointmentId}/export/status/${taskId}`)
}

// 下载预约详情PDF文件
export function downloadAppointmentDetailPDF(appointmentId, taskId) {
  const token = localStorage.getItem('mental_token')
  return fetch(`${aiUrl}/api/teacher/appointment/${appointmentId}/export/download/${taskId}`, {
    method: 'GET',
    headers: {
      'token': token,
      'Authorization': `Bearer ${token}`
    }
  })
}

// ========== 对话灵悦历史记录接口 ==========
const lingyueTalkUrl = 'https://www.ai-lingxin.com:6443/api/lingyue_talk'
export const lingyueTalkUsageEndUrl = `${lingyueTalkUrl}/usage/end`

// 获取对话灵悦历史记录（按日期）
export function getLingyueTalkHistory(params) {
  return get(`${lingyueTalkUrl}/history`, params)
}

// 删除对话灵悦历史记录（按日期/单轮/批量轮次）
export function deleteLingyueTalkHistory(params) {
  return post(`${lingyueTalkUrl}/history/delete`, params)
}

// 获取对话灵悦使用时长状态
export function getLingyueTalkUsageStatus(params) {
  return get(`${lingyueTalkUrl}/usage/status`, params)
}

// 获取对话灵悦隐私与权限授权状态
export function getLingyueTalkAuthorizationStatus(params) {
  return get(`${lingyueTalkUrl}/authorization/status`, params)
}

// 同意对话灵悦隐私与权限授权
export function acceptLingyueTalkAuthorization(params) {
  return post(`${lingyueTalkUrl}/authorization/accept`, params)
}

// 撤回对话灵悦隐私与权限授权
export function revokeLingyueTalkAuthorization(params) {
  return post(`${lingyueTalkUrl}/authorization/revoke`, params)
}

// 开始对话灵悦使用计时会话
export function startLingyueTalkUsage(params) {
  return post(`${lingyueTalkUrl}/usage/start`, params)
}

// 对话灵悦使用计时心跳
export function heartbeatLingyueTalkUsage(params) {
  return post(`${lingyueTalkUrl}/usage/heartbeat`, params)
}

// 结束对话灵悦使用计时会话
export function endLingyueTalkUsage(params) {
  return post(lingyueTalkUsageEndUrl, params)
}

// ========== HTTP 文本对话接口 ==========
// 在开发环境使用本地代理（通过 webpack dev server），避免跨域问题
export function sendTextChat(params) {
  return post(`https://www.ai-lingxin.com:6443/wshttp/chat`, params)
}

// ========== 学生对话历史记录接口 ==========
// 获取学生的对话历史列表
export function getStudentDialogueHistory(stu_id) {
  return get(`${schoolUrl}/student/dialogue_history/${stu_id}`)
}

// 获取学生对话详情
export function getStudentDialogueDetail(data_str, session_id_or_user_id, user_id) {
  // 支持两种调用方式：
  // 1. getStudentDialogueDetail(data_str, session_id, user_id) - 三个参数，传 session_id
  // 2. getStudentDialogueDetail(data_str, user_id) - 两个参数，不传 session_id

  let actualUserId = user_id;
  let actualSessionId = session_id_or_user_id;

  if (user_id === undefined) {
    // 只传了两个参数，第二个参数是 user_id
    actualUserId = session_id_or_user_id;
    actualSessionId = '';
  }

  const detailUrl = 'https://www.ai-lingxin.com:6443/api/school/manage/student/dialogue_history_detail'
  const payload = {
    data_str: data_str,
    user_id: actualUserId
  }

  // 如果有 session_id，则加入到请求体
  if (actualSessionId) {
    payload.session_id = actualSessionId;
  }

  return post(detailUrl, payload)
}

// 答题记录详情接口
export function teamtestAnswerRecordDetail(params) {
  return post('https://www.ai-lingxin.com:6443/api/teamtest/manage/answer_record_detail', params)
}

// 灵悦对话轮次排名表
export function getDialogueUsageRanking(params) {
  return post('https://www.ai-lingxin.com:6443/api/school/manage/home_page/dialogue_usage_ranking', params)
}

// ========== 个人档案页 - 测评记录和预约记录 ==========

// 获取团测记录列表
export function getTeamtestRecordList(params) {
  return post('https://www.ai-lingxin.com:6443/api/school/manage/student/teamtest_record_list', params)
}

// 查看选择题团测报告
export function viewTeamtestChoiceReport(params) {
  return post('https://www.ai-lingxin.com:6443/api/teamtest/manage/stu_by_id', params)
}

// 查看论述题团测报告
export function viewTeamtestDiscussReport(params) {
  return post('https://www.ai-lingxin.com:6443/api/school/manage/team_assess/stu_by_id', params)
}

// 获取预约记录列表
export function getAppointmentRecordList(params) {
  return get('https://www.ai-lingxin.com:6443/api/teacher/appointments', params)
}

// 学生账号模糊匹配
export function searchStudentAccount(params) {
  return post('https://www.ai-lingxin.com:6443/api/school/manage/student/student_account', params)
}



// WEBPACK FOOTER //
// ./src/service/api/getData.js